
import { useEffect, useCallback } from 'react';

interface PerformanceOptimizerProps {
  children: React.ReactNode;
}

const PerformanceOptimizer = ({ children }: PerformanceOptimizerProps) => {
  // Preload critical resources
  const preloadCriticalResources = useCallback(() => {
    // Preload hero images
    const heroImages = [
      '/lovable-uploads/ad558071-0db2-4301-9fb5-c1235ec6c9b2.png',
      '/lovable-uploads/c325d0e4-f21b-4854-acf2-360ae2b9ab61.png'
    ];

    heroImages.forEach(src => {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = src;
      document.head.appendChild(link);
    });

    // Preconnect to external domains
    const domains = [
      'https://challenges.cloudflare.com',
      'https://fonts.googleapis.com',
      'https://fonts.gstatic.com'
    ];

    domains.forEach(domain => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = domain;
      if (domain.includes('gstatic')) {
        link.crossOrigin = 'anonymous';
      }
      document.head.appendChild(link);
    });
  }, []);

  // Optimize viewport for mobile
  const optimizeViewport = useCallback(() => {
    const viewport = document.querySelector('meta[name="viewport"]');
    if (viewport) {
      viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, viewport-fit=cover');
    }
  }, []);

  // Add performance monitoring
  const monitorPerformance = useCallback(() => {
    if ('performance' in window && 'PerformanceObserver' in window) {
      try {
        // Monitor Core Web Vitals
        const observer = new PerformanceObserver((list) => {
          for (const entry of list.getEntries()) {
            if (entry.entryType === 'largest-contentful-paint') {
              // LCP tracked
            }
            if (entry.entryType === 'first-input') {
              // FID tracked
            }
            if (entry.entryType === 'layout-shift') {
              // CLS tracked
            }
          }
        });

        observer.observe({ entryTypes: ['largest-contentful-paint', 'first-input', 'layout-shift'] });
      } catch (error) {
        // Performance monitoring not supported
      }
    }
  }, []);

  useEffect(() => {
    preloadCriticalResources();
    optimizeViewport();
    monitorPerformance();
  }, [preloadCriticalResources, optimizeViewport, monitorPerformance]);

  return <>{children}</>;
};

export default PerformanceOptimizer;
